import { Separator } from '@/components/ui/separator';
import { PromptEditor } from './PromptEditor';
import { GenerationRunsTable } from './GenerationRunsTable';
import { ExportDialog } from './ExportDialog';
import { AuditPanel } from './AuditPanel';
import { QueueDashboard } from './QueueDashboard';
import { PipelineConfigPanel } from './PipelineConfigPanel';
import { MatchingConfigPanel } from './existing-posts/MatchingConfigPanel';
import type { ThematicMap } from '@/types/thematicMaps';

interface SettingsExportTabProps {
  map: ThematicMap;
  onProfilesChanged?: () => void;
}

export function SettingsExportTab({ map }: SettingsExportTabProps) {
  return (
    <div className="space-y-8">
      <section>
        <div className="flex items-center justify-between mb-3">
          <h3 className="text-base font-semibold">Eksport</h3>
          <ExportDialog map={map} />
        </div>
        <p className="text-sm text-muted-foreground">
          Eksportuj mapę jako JSON (pełna) lub CSV (flat nodes).
        </p>
      </section>

      <Separator />

      <section>
        <h3 className="text-base font-semibold mb-3">Profil autora</h3>
        <p className="text-sm text-muted-foreground mb-4">
          Profil autora jest teraz dostępny w kroku <strong>Profil</strong> w pipeline (obok Audyt).
          Tam możesz wygenerować, edytować i zarządzać profilem pisarskim.
        </p>
      </section>

      <Separator />

      <section>
        <PipelineConfigPanel />
      </section>

      <Separator />

      <section>
        <h3 className="text-base font-semibold mb-3">Matcher — Istniejące wpisy</h3>
        <MatchingConfigPanel />
      </section>

      <Separator />

      <section>
        <h3 className="text-base font-semibold mb-3">Prompty AI (pipeline)</h3>
        <p className="text-sm text-muted-foreground mb-4">
          Szablony promptów pipeline'u (macro, seeds, nodes, encje, relacje, SCN, Content Engine).
          Prompty do generowania treści (plan + pełna) konfigurowane są w profilu persony powyżej.
          Zmienne: {'{{macro_statement}}'}, {'{{scope_in}}'}, {'{{seed_name}}'}, itp.
        </p>
        <PromptEditor />
      </section>

      <Separator />

      <section>
        <h3 className="text-base font-semibold mb-3">SCN Compliance Audit</h3>
        <AuditPanel mapId={map.id} existingAudit={map.audit_report} />
      </section>

      <Separator />

      <section>
        <h3 className="text-base font-semibold mb-3">Kolejki generowania i publikacji</h3>
        <QueueDashboard mapId={map.id} />
      </section>

      <Separator />

      <section>
        <h3 className="text-base font-semibold mb-3">Logi generacji AI</h3>
        <GenerationRunsTable mapId={map.id} />
      </section>
    </div>
  );
}
